import { Col, Container, Row } from 'react-bootstrap'
import styled from 'styled-components'
import Box from '~/components/UI/Box'
import Text from '~/components/UI/Text'
import { Trans, useTranslation } from '~/i18n'
import getcdn from '~/modules/get_cdn_link'
import breakpoints from '~/components/UI/breakpoints'
import Button from '~/components/UI/Button'
import Image from '~/components/UI/Image'
import LabelNew from './LabelNew'
import isMobileSize from '~/modules/isMobileSize'
import { ROUTES } from '~/constant'
import { ReactChild } from 'react'
import { observer } from 'mobx-react-lite'
import config from '~/stores/Config'

const MyContainer = styled(Box)`
  --height: auto;
  height: var(--height);
  background: linear-gradient(116deg, #0092ff, #0055ff);
  ${breakpoints.md} {
    background: linear-gradient(96deg, #0099ff, #0055ff);
    --height: 400px;
    padding-top: 50px;
  }
  ${breakpoints.lg} {
    --height: 600px;
  }
`

export const BoxDetails = styled(Box)`
  border: 1px solid #fff;
  border-radius: 4px;
  padding: 0 20px;
  height: 80px;
  background-color: rgba(255, 255, 255, 0.1);
`

const BoxImage = styled(Box)`
  position: relative;
  height: 400px;
  width: 280px;
  padding-top: 30px;
  display: none;
  ${breakpoints.md} {
    display: block;
  }
  ${breakpoints.lg} {
    height: 530px;
    width: 400px;
    img {
      width: auto;
      height: 100%;
    }
  }
`

const BoxImageMobile = styled(Box)`
  position: relative;
  height: 350px;
  width: 300px;
  margin: auto;
  ${breakpoints.md} {
    display: none;
  }
`

export const DesktopBoxContent: React.FC<{
  profit: ReactChild | string
  term: string
  minBalance: string
}> = ({ profit, term, minBalance }) => {
  const [t] = useTranslation()
  const isMobile = isMobileSize()

  if (!isMobile) {
    return (
      <BoxDetails margin="20px 0" flex justify="space-between" align="center">
        <Box height="auto">
          <Text color="#fff">{t('Lợi nhuận')}</Text>
          <Text size={18} lgSize={24} bold color="#fff">
            {profit}
          </Text>
        </Box>

        <Box height="auto">
          <Text color="#fff">{t('Thời hạn')}</Text>
          <Text size={18} lgSize={24} bold color="#fff">
            {term}
          </Text>
        </Box>

        <Box height="auto">
          <Text color="#fff">{t('Vốn tối thiểu')}</Text>
          <Text size={18} lgSize={24} bold color="#fff">
            {minBalance}
          </Text>
        </Box>
      </BoxDetails>
    )
  }

  return null
}

const MF = () => {
  const [t] = useTranslation()
  return (
    <MyContainer>
      <Container>
        <Row>
          <Col md={5}>
            <BoxImage>
              <Image height={400} width={280} src={getcdn('/images/home/mf-home.png?ver=1')} alt="ipad_saving" />
            </BoxImage>
          </Col>
          <Col sm={12} md={7}>
            <Box flex column height="100%" mdStyle={{ paddingLeft: '2%' }}>
              <LabelNew xsStyle={{ textAlign: 'center', marginTop: 30 }} mdStyle={{ textAlign: 'left' }} />
              <Text
                mdStyle={{ textAlign: 'left', padding: '0' }}
                xsStyle={{ textAlign: 'center', padding: '0 50px' }}
                color="#fff"
                size={36}
                lgSize={48}
                xlSize={56}
              >
                <Trans i18nKey="Đầu tư Chứng chỉ quỹ"></Trans>
              </Text>
              <Text mdStyle={{ textAlign: 'left' }} xsStyle={{ textAlign: 'center' }} color="#fff">
                {t(
                  'Dễ dàng đầu tư chứng chỉ quỹ với lợi nhuận cao được phát hành bởi các quỹ đầu tư uy tín. Vốn tham gia thấp và không mất phí trung gian.'
                )}
              </Text>
              <DesktopBoxContent
                profit={
                  <CenterView>
                    {config.mf?.interest + '%/' + t('năm')}
                    {config.mf?.promo_interest && <DiscountBadge>{t('Ưu đãi')}</DiscountBadge>}
                  </CenterView>
                }
                term={t('TERM_MF')}
                minBalance={t('MIN_BALANCE_MF')}
              />
              <Button
                maxWidth="100%"
                xsStyle={{ margin: '30px 0', justifyContent: 'center' }}
                target="_blank"
                rel="noreferrer"
                link
                href={ROUTES.MF_INFO}
                border="0"
                mdStyle={{ justifyContent: 'flex-start', margin: '0' }}
              >
                <Text bold color="#fff">
                  {t('Tìm hiểu thêm →')}
                </Text>
              </Button>

              <BoxImageMobile>
                <Image height={350} width={300} src={getcdn('/images/home/mf-home.png?ver=1')} alt="ipad_saving" />
              </BoxImageMobile>
            </Box>
          </Col>
        </Row>
      </Container>
    </MyContainer>
  )
}

export default observer(MF)

const DiscountBadge = styled(Text)`
  margin-left: 5px;
  bottom: 25px;
  background-color: rgb(234, 32, 103);
  padding: 3px 4px;
  font-size: 10px;
  border-radius: 20px;
  display: inline-block;
  color: white;
  text-transform: uppercase;
  font-weight: bold;
`

const CenterView = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`
